window.$ = window.jQuery = require('jquery');

require('../vendor/bootstrap/js/bootstrap.min');
require('../vendor/bootstrap/js/popper.min');

require('../vendor/plugins/js/modernizr-3.6.0.min');
require('../vendor/plugins/js/slick.min');
//require('../vendor/plugins/js/countdown.min');
require('../vendor/plugins/js/nice-select.min');
require('../vendor/plugins/js/jqueryui.min');
require('../vendor/plugins/js/image-zoom.min');
require('../vendor/plugins/js/imagesloaded.pkgd.min');
require('../vendor/plugins/js/instagramfeed.min');
require('../vendor/plugins/js/ajaxchimp');
require('../vendor/plugins/js/ajax-mail');
require('../vendor/plugins/js/ajaxchimp');
require('../vendor/plugins/js/jquery.inputmask');
require('../vendor/form-sender/js/jquery.vegasFormSender');
require('../vendor/form-sender/js/init');
require('../vendor/fancybox/jquery.fancybox');
require('../vendor/plugins/js/jquery.overlayScrollbars.min');

require('./modules/cart');
require('./modules/ym');

require('./main');
require('./custom');
require('./cart');

